import React, {PropTypes} from 'react';

class EmptyJavaScriptEvents extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        let jsEventData = 
        {
            BangoTransactionId: this.props.values.MerchantTransactionId,
            Msisdn: this.props.values.msisdn,
            BangoUserId: this.props.values.UserId,
            ResponseCode: this.props.values.PaymentResponseCode || 'ERROR'
        };
        parent.window.postMessage(JSON.stringify(jsEventData), '*')
    }

    render() {
        return (<div />);
    }
}

EmptyJavaScriptEvents.propTypes = {
    name: React.PropTypes.string.isRequired,
    values: React.PropTypes.object.isRequired,
    uiSpec: React.PropTypes.object.isRequired,
    textResources: React.PropTypes.object.isRequired,
    actions: React.PropTypes.object.isRequired
};


export default EmptyJavaScriptEvents;



/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Shared/EmptyJavaScriptEvents.js
 **/